import React from "react";

/**
 * Visuels de l'assistant, servis depuis public/ et non importes dans le bundle :
 * ce sont des PNG lourds, webpack les inlinerait pas mais les versionnerait a
 * chaque build alors qu'ils changent au rythme de la charte, pas du code.
 *
 * PUBLIC_URL garde le chemin correct si l'application est un jour deployee dans
 * un sous-repertoire.
 */
const asset = (name) => `${process.env.PUBLIC_URL}/${name}`;

export const IA_HERO_SRC = asset("poseidon_ai.png");

/**
 * Grand visuel d'accueil, affiche au debut d'une discussion.
 *
 * C'est le seul endroit ou un PNG est utilise : partout ailleurs l'assistant est
 * represente par l'icone vectorielle IaAssistantSvg, recolorable et legere.
 */
export const IaHero = ({ className = "" }) => (
  <img src={IA_HERO_SRC} alt="Poseidon" className={`iaHero ${className}`} />
);
